import { render, staticRenderFns } from "./faultReason.vue?vue&type=template&id=06287a29&scoped=true&"
import script from "./faultReason.vue?vue&type=script&lang=js&"
export * from "./faultReason.vue?vue&type=script&lang=js&"
import style0 from "./faultReason.vue?vue&type=style&index=0&id=06287a29&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06287a29",
  null
  
)

export default component.exports